const THREE = require('three');

export default function cam () {
  this.camera = new THREE.PerspectiveCamera( 75, 1, 0.1, 1000 )
  this.camera.position.set( 0, .8, 2 );
  this.camera.lookAt( 0, 0.4 );
  return this.camera;
}
